import React from 'react';

import { Menu } from '~/presentation/components/menu';

import { RegisterManager as RegisterUserForm } from '~/presentation/components/registerManager';

import { Container, Body, LockScroll } from './StyledRegisterManager';
import { History } from '~/main/routes';
import { PageHeader } from '~/presentation/components/header';
import { translator } from '~/presentation/components/i18n';

const RegisterManager: React.FC = (): JSX.Element => {
  return (
    <Container>
      <LockScroll>
        <Menu />
        <PageHeader
          title={translator('Cadastrar novo organizador')}
          confirmChanges
        />
      </LockScroll>
      <Body>
        <RegisterUserForm />
      </Body>
    </Container>
  );
};

export default RegisterManager;
